import React, { useState, useEffect } from "react";
import { getSignUrl, openSignUrl } from "../utils/HelperFunction";
import httpRequest from "../utils/Http";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const FileDownloadDropdown = ({ files, setReload, isDelete }) => {
  const [showModal, setShowModal] = useState(false);
  const [thumbUrl, setThumbUrl] = useState(null);

    useEffect(() => {
    const fetchThumbUrl = async () => {
      if (files && files.length > 0) {
        const firstFile = files[0];
        const isImage = firstFile?.file_url?.match(/\.(jpeg|jpg|png|gif|webp|bmp)$/i);

        if (isImage) {
          const signedUrl = await getSignUrl(firstFile.file_url);
          setThumbUrl(signedUrl);
        }
      }
    };

    fetchThumbUrl();
  }, [files]);

  if (!files || files.length === 0) return "";

  // Open modal
  const handleDownload = () => {
    setShowModal(true);
  };

  const handleDelete = async (fileId) => {
    if (fileId) {
      const res = await httpRequest(
        "deletepartfiles?file_id=" + fileId,
        {},
        "GET"
      );

      if (res.status === true) {
        setReload(true);
        toast.success("File deleted successfully.");
      }
    }
  };

  return (
    <span>
      {/* Thumbnail as clickable trigger */}
      <Link to="#" title="View Files" onClick={handleDownload} className="btn-link">
        {thumbUrl ? (
          <img
            src={thumbUrl}
            alt="Thumbnail"
            style={{
              width: "50px",
              height: "50px",
              objectFit: "cover",
              borderRadius: "4px",
              border: "1px solid #ccc"
            }}
          />
        ) : (
          "View Files"
        )}
      </Link>

      {/* Modal for multiple files */}
      {showModal && (
        <>
          <div
            className="modal fade show"
            id="modal-dues"
            style={{ display: "block" }}
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Available Files</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowModal(false)}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "justify" }}>File Name</th>
                          <th style={{ textAlign: "justify" }}>Download</th>
                          {isDelete && (
                            <th style={{ textAlign: "justify" }}>Delete</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {files.map((file, index) => (
                          <tr key={file?.id || file?.file_name || index}>
                            <td>{file.file_name}</td>
                            <td>
                              <button
                                title={`Download ${file.file_name}`}
                                onClick={() => openSignUrl(file.file_url)}
                                className="btn btn-sm btn-outline-primary"
                              >
                                <i className="fas fa-download"></i> Download
                              </button>
                            </td>
                            {isDelete && (
                              <td>
                                <button
                                  title={`Delete ${file.file_name}`}
                                  onClick={() => handleDelete(file.id)}
                                  className="btn btn-sm btn-outline-danger"
                                >
                                  <i className="fas fa-trash"></i> Delete
                                </button>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={() => setShowModal(false)}
          ></div>
        </>
      )}
    </span>
  );
};

export default FileDownloadDropdown;
